import React, { Component } from 'react';
import { getOwnerContract, getBankContract }  from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TransactionService } from '../../services/transactionService'
import Modal from '../modal'; // importing the Modal component


class Borrow extends Component {

    state = {
      lenders:[],
      userId: 0,
      userAddress: "",
      isConnected: false,
      isModalOpen: false,
      selectedLenderId: 0,
    };

    constructor(props) {
      super(props);
      if(props.router.params.id) {
          this.state.userId = props.router.params.id;
      } else {
          this.state.userId = 1;
      }
      this.props.onSetUserId(this.state.userId);
    }

    connectWallet = async () => {
      const wallet = await getWallet();
      if(!wallet.isReadOnly) {
          const browserAddresses = await wallet.provider.listAccounts();
          this.setState({ userAddress: browserAddresses[0], isConnected: true });
      } else {
          throw new Error('Wallet not connected');
      }
    } 

    async componentDidMount() {
      await this.connectWallet();

      const bankContract = await getBankContract();

      const lenderIds = await bankContract.getAllLenders();

      let lenders = [];
      for (let i = 0; i < lenderIds.length; i++) {

        const lenderLendAmount = await bankContract.lenderIdToLendAmount(lenderIds[i]);

        lenders.push({id: ethers.BigNumber.from(lenderIds[i]).toNumber(), amount: parseFloat(ethers.utils.formatUnits(lenderLendAmount, "mwei"))});
      }

      this.setState({ lenders: lenders });
      
    }

  borrow = async (lenderId) => {
    const wallet = await getWallet();
    if (!this.state.isConnected) {
      alert('Connect wallet');
      return;
    }
    this.setState({ selectedLenderId: lenderId, isModalOpen: true});
    // try {
    //   var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
    //   const lendingPromise = transactionService.borrowAndRegister(lenderId);
    //   await toast.promise(
    //     lendingPromise,
    //     {
    //       pending: `Registration in autorun inprocess`,
    //       success: `Successfull registered`,
    //       error: 'Failed'
    //     }
    //   )
    // } catch (error) {
    //   alert(error.message);
    // }
  }

  payDebt = async () => {
    const wallet = await getWallet();
    if (!this.state.isConnected) {
      alert('Connect wallet');
      return;
    }
    try {
      var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
      const lendingPromise = transactionService.payDebt();
      await toast.promise(
        lendingPromise,
        {
          pending: `Paying all debt`,
          success: `Successfull paid`,
          error: 'Failed'
        }
      )
    } catch (error) {
      alert(error.message);
    }
  }

  confirmBorrow = async () => {
    try {
      var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
      const lendingPromise = transactionService.borrowAndRegister(this.state.selectedLenderId);
      await toast.promise(
        lendingPromise,
        {
          pending: `Registration in autorun in-process`,
          success: `Successfull registered`,
          error: 'Failed'
        }

      )
      this.setState({ isModalOpen: false });
    } catch (error) {
      alert(error.message);
    }
  }

    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14 m-5">
              {this.state.isModalOpen && (
                <Modal onClose={() => this.setState({ isModalOpen: false})}>
                    <div style={{color: "black", fontSize: "30px"}} className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14 m-5">
                     <p>
                        Warning : within 90 days of borrowing, if you can't return funds 600 USDT to lender, your ID will be replaced by wallet of lender, please accept and hereby confirm this agreement.
                     </p>
                      <button onClick={this.confirmBorrow} style={{background: 'red'}} className="mt-10 flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 mt-10 py-5 !px-10 sm:py-5 sm:mt-7.5" >
                        Confirm
                      </button>
                    </div>
                  {/* <img style={{width: "400px"}} src="/logo/popup2.jpeg" className="" /> */}
                </Modal>
              )}
              <div className="col-sm-12 col-md-12 mobile-center text-center">
                  <h1 style={{ fontWeight: "bolder", fontSize: "40px" }}>
                   <span style={{ color: "#FDFBF7"}} >Borrow for Autorun Matrix</span>{" "}
                  </h1>
                <button style={{ background: '#BE9131' }}
                  className=" text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 mb-5 py-5 !px-10 sm:py-5 sm:mt-7.5"
                  onClick={this.payDebt} id="nextButton" >Pay All Debt </button>
                
                </div>
                <div className="flex overflow-hidden relative w-full flex-col bg-gray-800 rounded p-7.5 pb-5 sm:p-5 sm:pl-2.5 sm:pr-2.5 sm:rounded-none">
                  <div className="sm:rounded-none z-10 flex flex-1 flex-col w-full flex-col rounded overflow-hidden h-full min-h-90 sm:max-h-3/4">
                    <div className="overflow-auto">
                      <table className="min-w-max w-full table-auto border-white-100">
                        <thead>
                          <tr className="text-white text-xs border-b border-white-100">
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-left font-normal sm:p-3 "
                            >
                              Lenders
                            </th>
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-center font-normal sm:p-3"
                            >
                              Lend Amount
                            </th>
                            <th
                              style={{ fontSize: "1rem" }}
                              className="p-4 text-right font-normal sm:p-3"
                            >
                              Take loan for Autorun
                            </th>
                          </tr>
                        </thead>
                        <tbody className=" text-sm font-light align-baseline">
                          {this.state.lenders.map((lender, index) => {
                            return (<tr
                              style={{ border: "1px solid" }}
                              key={index}
                              className="border-b border-blue-100 last:border-none mt-1"
                            >
                              <td className=" p-3 text-left whitespace-nowrap sm:p-3">
                                <div
                                  style={{ fontSize: "15px" }}
                                  className="text-sm "
                                >
                                  ID {lender.id}
                                </div>
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-center whitespace-nowrap sm:p-3"
                              >
                                {lender.amount}
                              </td>
                              <td
                                style={{ fontSize: "15px" }}
                                className="p-2 text-right whitespace-nowrap sm:p-3"
                              >
                                <button style={{background: 'white'}}
                                        className=" text-base font-bold text-black rounded-mini sm:text-sm  py-1 !px-10 sm:py-5 sm:mt-7.5"
                                        onClick={() => this.borrow(lender.id)} id="" >CREDIT</button>
                              </td>
                            </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}
 
export default withWrapper(Borrow);